import { render, staticRenderFns } from "./s-form.vue?vue&type=template&id=28d6b4d0"
import script from "./s-form.vue?vue&type=script&lang=js"
export * from "./s-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports